'use client';

import { lazy, Suspense, useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const GiftMessageDrawer = lazy(() => import('./gift-message-drawer'));

interface GiftInformationProps {
    email?: unknown;
    message?: unknown;
}

export default function GiftInformation({ email, message }: GiftInformationProps): ReactElement | null {
    const { t } = useTranslation('cart');
    const [drawerLoaded, setDrawerLoaded] = useState(false);
    const [open, setOpen] = useState(false);
    const recipientEmail = typeof email === 'string' ? email.trim() : '';
    const giftMessage = typeof message === 'string' ? message.trim() : '';

    if (!recipientEmail) {
        return null;
    }

    return (
        <>
            <div className="flex w-full items-baseline justify-between gap-2 text-neutral-10">
                <p className="body-copy-s min-w-0 break-all">{recipientEmail}</p>
                {giftMessage ? (
                    <Button
                        type="button"
                        hierarchy="tertiary"
                        mode="light"
                        size="small"
                        className="body-copy-s-bold w-fit shrink-0 underline underline-offset-4"
                        onClick={() => {
                            setDrawerLoaded(true);
                            setOpen(true);
                        }}>
                        {t('giftMessage.messageLabel')}
                    </Button>
                ) : null}
            </div>

            {drawerLoaded && giftMessage ? (
                <Suspense fallback={null}>
                    <GiftMessageDrawer message={giftMessage} open={open} onOpenChange={setOpen} />
                </Suspense>
            ) : null}
        </>
    );
}
